import { Component, OnInit } from '@angular/core';

import { TransactionsService } from '../../services/transactions.service';

interface Week {
  weekNumber: number;
  startDate: Date;
  endDate: Date;
  transactions: any[];
}

@Component({
  selector: 'ap-wage-sustainability',
  templateUrl: './wage-sustainability.component.html',
  styleUrls: ['./wage-sustainability.component.scss']
})
export class WageSustainabilityComponent implements OnInit {

  totalRevenue: number = 0;
  totalExpense: number = 0;
  totalProfit: number = 0;
  totalWages: number = 0;
  
  netDifference: number = 0;

  weeks: Week[] = [];
  
  constructor(private transactionService: TransactionsService) { }

  ngOnInit(): void {

    this.generateWeeksArray();

    let temp = {};
    let query:any = {};

    let currentDate = new Date();
    currentDate.setDate(currentDate.getDate() - 28);

    temp["$gte"] = currentDate;
    query.date = temp;
    query.ignore = false;

    // Add up all the expenses
    query.account = "442829529";
    this.transactionService.find(query, 0, 0).subscribe((transactions) => {

      for (let i=0;i<transactions.length;i++) {
          this.totalExpense += transactions[i].amount;
      }

      this.totalProfit += this.totalExpense;
      this.totalExpense = this.totalExpense / 4;

      this.temp += 1;
      this.calcuate();
    });

    // Add up all the revenue
    query.account = "480004229";
    this.transactionService.find(query, 0, 0).subscribe((transactions) => {
      for (let i=0;i<transactions.length;i++) {
        this.totalRevenue += transactions[i].amount;
      }

      this.totalProfit += this.totalRevenue;
      this.totalRevenue = this.totalRevenue / 4;

      this.temp += 1;
      this.calcuate();
    });

    // Add up all wages outgoings
    query.category = "425866854";
    this.transactionService.find(query, 0, 0).subscribe((transactions) => {
      for (let i=0;i<transactions.length;i++) {
        if (transactions[i].amount < 0) {
          this.totalWages += transactions[i].amount;
        }
      }

      this.totalWages = this.totalWages / 4;

      this.temp += 1;
      this.calcuate();
    });
  }


  generateWeeksArray() {
    // Get all the weeks in the last 
    
    //console.log(this.getDaysArray(2022, 3));

    let curr = new Date(new Date().setHours(0, 0, 0, 0)); // get current date
    let first = curr.getDate() - curr.getDay() + 1; // First day is the day of the month - the day of the week
    
    let last = first + 6; // last day is the first day + 6
    
    let firstday = new Date(curr.setDate(first));
    let lastday = new Date(curr.setDate(last));
    lastday = new Date(lastday.setHours(23, 59, 59, 59));

    let oneWeek = 1000 * 60 * 60 * 24 * 7;
    let prevWeek = firstday;
    for (let i=0; i < 200; i++) {
      prevWeek = new Date(prevWeek.getTime() - oneWeek);
      

      console.log(prevWeek);
    }

  }


  temp = -3;
  calcuate() {
    //console.log(this.temp);
    if (this.temp == 0) {
      //console.log(((this.totalWages*-1) / 4) / 100);

      this.totalProfit = this.totalProfit / 4;

      this.netDifference = this.totalProfit + this.totalWages;
    }
  }

  getDaysArray(year, month) {
    var numDaysInMonth, daysInWeek, daysIndex, index, i, l, daysArray;

    numDaysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    daysInWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    daysIndex = { 'Sun': 0, 'Mon': 1, 'Tue': 2, 'Wed': 3, 'Thu': 4, 'Fri': 5, 'Sat': 6 };
    index = daysIndex[(new Date(year, month - 1, 1)).toString().split(' ')[0]];
    daysArray = [];

    for (i = 0, l = numDaysInMonth[month - 1]; i < l; i++) {
        daysArray.push((i + 1) + '. ' + daysInWeek[index++]);
        if (index == 7) index = 0;
    }

    return daysArray;
}

}
